<template>
  <!-- 游戏训练营-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo21" :type="'yxxly'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo21 from '@/assets/images/logo21.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo21
    }
  }
}
</script>